import { dataElement } from 'dls-icons-data'
import { createIcon } from '../common'

const IconElement = /*#__PURE__*/createIcon(dataElement)
export default IconElement
